<template>
  <button
    v-shortcut.meta="{ key: 191 }"
    type="button"
    class="btn btn-outline live-btn text-big"
    :class="{
      'live-btn--on': active
      , 'live-btn--off': !active
      , 'live-btn--animated': animate && active
    }"
    :disabled="disabled"
    @shortcut="handleClick"
    @click="handleClick"
  >
    <span class="live-btn__circle" />
    <slot name="title" />
  </button>
</template>

<script>
export default {
  props: {
    active: Boolean,
    animate: Boolean,
    disabled: Boolean
  },
  emits: ['toggle'],
  methods: {
    handleClick() {
      if (!this.disabled) {
        this.$emit('toggle')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@ui/styles/src/scss/utils/lib";

  $circleSize: 9px;
  $bouncingIndent: 110%;

  .live-btn {
    $this: &;

    position: relative;
    padding: 0 7px;
    overflow: hidden;
    color: $secondaryColor;
    line-height: _rem(32);
    letter-spacing: _rem(1);
    text-transform: uppercase;
    outline: none;
    cursor: pointer;
    user-select: none;

    &:focus {
      outline: none;
      box-shadow: none;
    }

    &:disabled {
      opacity: 0.4;
    }

    &--on {
      opacity: 1;
    }

    &--off {
      opacity: 0.6;
    }

    &--animated {
      &::before {
        @include pseudo;

        bottom: 0;
        left: 0;
        width: 100%;
        background-color: $redHighlight;
        box-shadow: 0 0 3px 1px scale-color($redHighlight, $lightness: 5%);
        transform: translate(-$bouncingIndent, 0);
        animation: bouncing 2s infinite ease-in-out;
      }
    }

    &__circle {
      display: inline-block;
      width: $circleSize;
      height: $circleSize;
      margin-right: 4px;
      border-radius: 50%;

      #{$this}--on & {
        background-color: $redHighlight;
        box-shadow: 0 0 8px 1px scale-color($redHighlight, $lightness: 5%);
        opacity: 0.7;
      }

      #{$this}--off & {
        background-color: $secondaryColor;
      }
    }
  }

  @keyframes bouncing {
    0% { transform: translateX(-$bouncingIndent); }
    20% { transform: translateX(-$bouncingIndent); }
    80% { transform: translateX($bouncingIndent); }
    100% { transform: translateX($bouncingIndent); }
  }
</style>

